<template>
  <div class="set" style="background-color:#fff;position: relative;">
    <van-nav-bar
      title="用户须知"
      @click-left="onClickLeft"
      left-arrow
    ></van-nav-bar>

    <div
      ref="htstr"
      class="content"
      v-html="html"
      style="padding-top: 60px;padding-bottom:1rem;padding:20px 20px 1rem 20px;"
    ></div>
    <div style="height: 1rem;"></div>
  </div>
</template>

<script>
import request from "@utils/request";
export default {
  //   name: "",
  data() {
    return {
      html: ""
    };
  },
  created() {
    this.contract();
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    async contract() {
      request.get("/login/reg/agree", {}, { login: false }).then(res => {
        console.log("合同");
        console.log(res);
        this.html =
          '<meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no">' +
          res.data;
        this.ref(res.data);
        console.log(this.html);
      });
    },
    ref: function() {
      let _self = this;
      _self.$nextTick(function() {
        this.html.replace(/<script.*?>([\s\S]+?)<\/script>/gim, function(
          _,
          js
        ) {
          let regJs = js;
          var ele = document.createElement("script");
          ele.innerHTML = regJs;
          _self.$refs.htstr.append(ele);
        });
      });
    }
  },
  components: {}
};
</script>
<style scoped lang="less">
.teamindeximg {
  width: 100%;
}

.teamtitle {
  background-color: #f6f6fe;
  font-size: 15px;
  display: flex;
  padding: 10px;
  box-sizing: border-box;
  align-items: center;
  width: calc(100% - 12px);
}

.teamnum {
  background-color: #067594;
  color: #fff;
  padding: 0 8px;
  border-radius: 20px;
  margin-left: 3px;
  font-size: 13px;
  height: 18px;
  line-height: 20px;
}

.teamli {
  border-bottom: 1px solid #f6f6f6;
  padding: 7px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;

  font-size: 15px;
}

.teamlist {
  padding-right: 12px;
}

.teamlil {
  display: flex;
  align-items: center;
}

.teamlil img {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 100%;
  margin-right: 20px;
}
/deep/ .van-nav-bar .van-icon {
  color: #333;
}

/deep/ #all {
  width: 780px;
  padding: 100px 32px;
  background: #fff;
}
</style>

